import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppInfo } from '@jwp/ott-hooks-react/src/useAppInfo';
import HTMLRenderer from '../HTMLRender/HTMLRender';
import { useAppConfig } from '@jwp/ott-hooks-react/src/useAppConfig';
import MarkdownComponent from '../MarkdownComponent/MarkdownComponent';
import { markdownPageEnglish, markdownPageSpanish } from './PrivacyPolicyContent';
import styles from './PrivacyPolicy.module.scss';

import { useConfigStore } from '@jwp/ott-common/src/stores/ConfigStore';
type Props = {
  panelClassName?: string;
  panelHeaderClassName?: string;
};

const PrivacyPolicy = ({ panelClassName, panelHeaderClassName }: Props): JSX.Element => {
  const { canShowPrivacyPolicy } = useAppConfig();
  const { privacyPolicy } = useConfigStore.getState();
  const { i18n, t } = useTranslation('common');

  console.log('privacyPolicy', privacyPolicy);

  const markdownContent = () => {
    if (i18n.language === 'en') {
      return markdownPageEnglish;
    } else if (i18n.language === 'es') {
      return markdownPageSpanish;
    } else return 'Language not supported';
  };

  if (!privacyPolicy?.en && !privacyPolicy?.es && canShowPrivacyPolicy) {
    return (
      <section className={panelClassName}>
        <div className={panelHeaderClassName}>
          <h2>{t('footer.privacy_policy')}</h2>
        </div>
        <MarkdownComponent className={styles.about} markdownStyle={styles.markdown} markdownString={markdownContent()} />
      </section>
    );
  }
  return (
    <>
      <section className={panelClassName}>
        <HTMLRenderer className={styles.legalDocsContainer} html={i18n.language == 'es' && privacyPolicy ? privacyPolicy.es : privacyPolicy?.en} />
      </section>
    </>
  );
};

export default PrivacyPolicy;
